// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"58482de7","703":"3254518a","787":"8c889de3"}[chunkId] + ".chunk.js";
};